import { render } from "./DetailViewModal.vue?vue&type=template&id=3824528d&scoped=true"
import script from "./DetailViewModal.vue?vue&type=script&lang=js"
export * from "./DetailViewModal.vue?vue&type=script&lang=js"

import "./DetailViewModal.vue?vue&type=style&index=0&id=3824528d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3824528d"]])

export default __exports__